import styled from "styled-components";
import pipe from "../../assets/pipe.jpg";
const fontSize = localStorage.getItem("fontSize");

export const CollectionHeader = styled.header`
  background: url(${pipe});
  width: 100%;
  height: 50%;
  display: flex;
  background-repeat: no repeat;
  background-position: center;
  background-size: cover;
  h1 {
    color: white;
    font-size: calc(${fontSize} + 2rem);
  }
`;

export const CollectionMainContainer = styled.div`
  width: 100%;
  margin-top: 6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
`;

export const SecondSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: flex-start;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const SectionBadge = styled.div`
  background: #62aa51;
  color: white;
  width: 100%;
  p {
    width: 80%;
    margin: 0 auto;
    text-align: center;
  }
`;

export const FinalSection = styled.section`
  width: 80%;
  display: flex;
  align-items: center;
  flex-direction: column;
  h2 {
    color: #101e8e;
  }
  gap: 1rem;
`;
